module.exports = __webpack_public_path__ + "static/img/FQA_ZH_3.c4bc073.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/FQA_ZH_3.png
// module id = JaAr
// module chunks = 4